import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { MenuUpdateWidget } from '@/widgets/menu-update-widget'

export const Route = createFileRoute('/_auth/canteen/menu-settings/catalog-menu/update/$menuId')({
  validateSearch: (search: Record<string, unknown>) => ({
    isDraft: search.isDraft === true || search.isDraft === 'true',
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PageWrapper title={t('Редактирование меню')}>
      <MenuUpdateWidget />
    </PageWrapper>
  )
}
